import { useSelector, useDispatch } from 'react-redux'
import { useCallback, useMemo } from 'react'
import { selectIsVbUploading, selectPendingVbImage } from '../vb/reducer'
import { selectIsZaConfigPending } from '../root/reducer'
import { setVirtualBackground } from '../vb/actions'
import Spinner from '../components/Spinner.js'

function SetBackgroundButton({ image, index, resultSelected }) {
  const dispatch = useDispatch()
  const isVbUploading = useSelector(selectIsVbUploading)
  const pendingVbImage = useSelector(selectPendingVbImage)
  const configIsPending = useSelector(selectIsZaConfigPending)

  const setVb = useCallback(() => {
    dispatch(setVirtualBackground({ image }))
  }, [image, dispatch])

  const isCurrentImage = useMemo(() => {
    if (image && pendingVbImage) {
      return image.id === pendingVbImage.id
    }
  }, [image, pendingVbImage])

  const ariaLabelText = image.alt || image.id
  return (
    <button
      data-id={`insideImagesContainer_${index}`}
      aria-label={`Set background for ${ariaLabelText}`}
      onClick={setVb}
      tabIndex={resultSelected ? '0' : '-1'}
      className="SearchResult__button"
      id={
        isVbUploading || configIsPending
          ? 'set-background-preparing-button'
          : ''
      }
      disabled={isVbUploading || configIsPending}
    >
      {isVbUploading && isCurrentImage ? (
        <>
          <Spinner /> Preparing
        </>
      ) : (
        'Set background'
      )}
    </button>
  )
}

export default SetBackgroundButton
